module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./TransitView.js"));
	}, "TransitView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TransitView!./src/pages/Transit/TransitView.js
// module id = 1291
// module chunks = 431